module.exports = __webpack_public_path__ + "img/DSC_0077.bfa3aa1d.jpg";